import { X } from "lucide-react";

type ClearInputButtonProps = {
  onClick: () => void;
};

export function ClearInputButton({ onClick }: ClearInputButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Limpar pesquisa"
      className="absolute right-2.5 top-1/2 -translate-y-1/2 rounded-sm text-muted-foreground transition hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <X className="h-4 w-4" />
    </button>
  );
}
